import { Button, ButtonProps } from "@p0security/ui";
import { UserRole } from "components/Login";
import { useHasRole } from "hooks/useHasRole";
import React from "react";

interface AuthzButtonProps extends ButtonProps {
  roles: UserRole | UserRole[] | "all";
  disabledProps?: boolean;
}

const AuthzButton = React.forwardRef<HTMLButtonElement, AuthzButtonProps>(
  ({ roles, disabledProps, children, ...otherProps }, ref) => {
    const hasRole = useHasRole(roles);

    return (
      <Button ref={ref} disabled={!hasRole || disabledProps} {...otherProps}>
        {children}
      </Button>
    );
  }
);

AuthzButton.displayName = "AuthzButton";

export { AuthzButton };
